import { Graphics, Container, Text, Point, ObservablePoint, Texture, extras } from 'pixi.js'
import helpers from '../helpers'
import { app, grid } from './index'
import Room from './Room'

export default class ItemController extends Graphics {

  constructor(item) {
    super()

    this.pivot.x = 60

    // 対象のアイテム
    this.item = item

    // コントローラー
    this.controller = new Container()
    this.controller.visible = false
    this.addChild(this.controller)

    // コントローラー背景
    this.backGround = new Graphics()
    this.backGround.lineStyle(1, 0x999999)
    this.backGround.beginFill(0xD3E69C, 1)
    this.backGround.drawRoundedRect(0, 0, 50, 127, 6)
    this.controller.addChild(this.backGround)

    let png = !helpers.methods.useSvg()

    // 反転ボタン
    this.btnFlip = new Graphics()
    this.btnFlip.tint = 0xCCCCCC
    this.btnFlip.lineStyle(1, 0x506236);
    this.btnFlip.beginFill(0x99CC66, 1);
    this.btnFlip.drawRoundedRect(0, 0, 36, 33, 3);
    this.btnFlip.endFill();
    this.btnFlip.position.set(7, 7);
    this.btnFlip.cursor = 'pointer'
    this.controller.addChild(this.btnFlip)
    let iconFlipSVG = '/simulator_assets/img/iconFlip.svg'
    if (png) iconFlipSVG = iconFlipSVG.replace('.svg', app.renderer.resolution > 1 ? '_2x.png' : '.png')
    let iconFlip = new PIXI.Sprite.from(new PIXI.Texture.fromImage(iconFlipSVG, false, PIXI.SCALE_MODES.LINEAR, app.renderer.resolution))
    iconFlip.scale.set(1 / app.renderer.resolution)
    iconFlip.anchor.set(0.5)
    iconFlip.position.set(this.btnFlip.width / 2, this.btnFlip.height / 2)
    this.btnFlip.addChild(iconFlip)
    let labelFlip = this.addBtnLabel(this.btnFlip, '反転する')
    this.bindBtnEvents(this.btnFlip, labelFlip, 'flip')

    // 回転ボタン
    this.btnTurn = new Graphics()
    this.btnTurn.tint = 0xCCCCCC
    this.btnTurn.lineStyle(1, 0x506236);
    this.btnTurn.beginFill(0x99CC66, 1);
    this.btnTurn.drawRoundedRect(0, 0, 36, 33, 3);
    this.btnTurn.endFill();
    this.btnTurn.position.set(7, 7 + 33 + 7);
    this.btnTurn.cursor = 'pointer'
    this.controller.addChild(this.btnTurn)
    let iconTurnSVG = '/simulator_assets/img/iconTurn.svg'
    if (png) iconTurnSVG = iconTurnSVG.replace('.svg', app.renderer.resolution > 1 ? '_2x.png' : '.png')
    let iconTurn = new PIXI.Sprite.from(new PIXI.Texture.fromImage(iconTurnSVG, false, PIXI.SCALE_MODES.LINEAR, app.renderer.resolution))
    iconTurn.scale.set(1 / app.renderer.resolution)
    iconTurn.anchor.set(0.5)
    iconTurn.position.set(this.btnTurn.width / 2, this.btnTurn.height / 2)
    this.btnTurn.addChild(iconTurn)
    let labelTurn = this.addBtnLabel(this.btnTurn, '回転する')
    this.bindBtnEvents(this.btnTurn, labelTurn, 'turn')

    // 削除ボタン
    this.btnTrash = new Graphics()
    this.btnTrash.tint = 0xCCCCCC
    this.btnTrash.lineStyle(1, 0x506236);
    this.btnTrash.beginFill(0x99CC66, 1);
    this.btnTrash.drawRoundedRect(0, 0, 36, 33, 3);
    this.btnTrash.endFill();
    this.btnTrash.position.set(7, 7 + 33 + 7 + 33 + 7);
    this.btnTrash.cursor = 'pointer'
    this.controller.addChild(this.btnTrash)
    let iconTrashSVG = '/simulator_assets/img/iconTrash.svg'
    if (png) iconTrashSVG = iconTrashSVG.replace('.svg', app.renderer.resolution > 1 ? '_2x.png' : '.png')
    let iconTrash = new PIXI.Sprite.from(new PIXI.Texture.fromImage(iconTrashSVG, false, PIXI.SCALE_MODES.LINEAR, app.renderer.resolution))
    iconTrash.scale.set(1 / app.renderer.resolution)
    iconTrash.anchor.set(0.5)
    iconTrash.position.set(this.btnTrash.width / 2, this.btnTrash.height / 2)
    this.btnTrash.addChild(iconTrash)
    let labelTrash = this.addBtnLabel(this.btnTrash, '削除する')
    this.bindBtnEvents(this.btnTrash, labelTrash, 'trash')

    this.item.on('focus', () => this.focus())
    this.item.on('blur', () => this.blur())

    this.item.on('drag', () => this.drag())
    this.item.on('drop', () => this.drop())

    this.item.on('updatecoordinate', () => this.updateCoordinate())

    this.updateCoordinate()

    return this
  }

  updateCoordinate() {
    this.position.set(this.item.position.x, this.item.position.y)
  }

  focus() {
    this.updateCoordinate()
    this.controller.visible = true
  }

  blur() {
    this.controller.visible = false
  }

  drag() {
    this.controller.visible = false
  }

  drop() {
    this.controller.visible = true
  }

  addBtnLabel(btn, labelText) {

    let label = new Graphics()
    label.visible = false
    label.beginFill(0x000000, 0.6)
    label.drawRoundedRect(0, 0, 62, 20, 4);
    label.position.set((36-62)/2, -13)

    let text = new Text(labelText, {align: 'center', fill: 0xFFFFFF, fontSize: 12})
    text.anchor.set(0.5, 0.5)
    text.position.set(label.width / 2, label.height / 2)
    label.addChild(text)

    btn.addChild(label)

    return label
  }

  bindBtnEvents(btn, label, action) {
    btn.interactive = true
    btn.on('pointerover', e => {
      btn.tint = 0xFFFFFF
      label.visible = true
    })
    btn.on('pointerout', e => {
      btn.tint = 0xCCCCCC
      label.visible = false
    })
    btn.on('pointerdown', e => {
      e.stopPropagation()

      switch(action) {
        case 'flip':
          this.item.flip()
          break;
        case 'turn':
          this.item.turn()
          break;
        case 'trash':
          this.item.trash()
          break;
      }
    })
  }
}



// WEBPACK FOOTER //
// ./assets/js/display/ItemController.js